import Joi from 'joi';
import { AxiosError } from 'axios';
import api from '../api';

/**
 * Login
 * @param {object} queryParams - The query parameters.
 * @param {string} queryParams.email - The email of the user.
 * @param {string} queryParams.password - The password of the user.
 * @returns {Promise<
 * {token: string}>} - auth tokens.
 */
export const login = async (queryParams) => {
  const result = await api.post('/login', queryParams);

  try {
    const schema = Joi.object({
      token: Joi.string().required(),
      refresh_token: Joi.string().required(),
    }).required();

    await schema.validateAsync(result.data, { allowUnknown: true });
  } catch (/** @type {any} */ error) {
    throw new AxiosError('', `API response do not match login Schema : ${error.message}`);
  }
  return result.data;
};

/**
 * Reset password
 * @param {object} params
 * @param {string} params.email
 * @param {string} params.returnUrl
 * @param {'admin' | 'worker'} params.origin
 * @returns {Promise<any>} - 204 return code
 */
export const resetPassword = async (params) => {
  const result = await api.post(
    '/reset-password',
    { email: params.email, returnUrl: params.returnUrl },
    {
      baseURL: import.meta.env[`VITE_API_URL_${params.origin.toUpperCase()}`],
    },
  );
  return result.status;
};

/**
 * Update password
 * @param {object} params
 * @param {string} params.token
 * @param {string} params.newPassword
 * @param {'admin' | 'worker'} params.origin
 * @returns {Promise<any>} - 201 return code
 */
export const updatePassword = async (params) => {
  const result = await api.post('/update-password', { password: params.newPassword }, {
    baseURL: import.meta.env[`VITE_API_URL_${params.origin.toUpperCase()}`],
    headers: { Authorization: `Bearer ${params.token}` },
  });
  return result.status;
};

export const refreshAuth = async () => {
  const localStorageAuthRaw = window.localStorage.getItem('auth');

  /**
   * @type {Auth | null}
   */
  const localStorageAuth = localStorageAuthRaw ? JSON.parse(localStorageAuthRaw) : null;
  const result = await api.post('/refresh-token', { headers: { Authorization: `Bearer ${localStorageAuth.refresh_token}` } });
  return result.data;
};
